// utility to log GQL errors
export var INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export var logGQLErrors = function logGQLErrors(message, error) {
  var _error$graphQLErrors;

  // ignoring this as optional chaining has open issues with satisfying branch coverage: https://github.com/istanbuljs/istanbuljs/issues/516

  /* istanbul ignore next */
  error === null || error === void 0 ? void 0 : (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : _error$graphQLErrors.forEach(function (err) {
    var _err$extensions;

    if ((err === null || err === void 0 ? void 0 : (_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.code) == INTERNAL_SERVER_ERROR) console.error("GQL error: ".concat(message, ": "), err.message);
  });
};